import { createTransport } from "./transportFactory.js";

const { transport, baseUrl } = createTransport("prospect");

export const prospectTransport = transport;
export const PROSPECT_BASE_URL = baseUrl;
